<template>
  <div class="d-flex justify-content-between">
    <div class="d-flex flex-column">
      <span class="font-weight-bold font-color-primary">{{ product.name }}</span>
      <span class="small">{{ `${$t('general.amount')}: ${product.count}` }}</span>
    </div>
    <div v-if="!readOnly">
      <el-button type="danger" icon="el-icon-delete" circle @click="$emit('removeItem', index)" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCartEntry',
  components: {},
  props: {
    index: {
      type: Number,
      default: -1,
    },
    product: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style scoped></style>
